import {AIUsageExportResult} from 'interfaces'
import {AIUsageService} from 'services/api'

import {useUsageExport, type UseUsageExportResult} from './useUsageExport'

const fetchAIUsageExport = (): Promise<AIUsageExportResult> =>
  AIUsageService.getAIUsageExport()

export const useAIUsageExport = (): UseUsageExportResult =>
  useUsageExport({
    fetchExport: fetchAIUsageExport,
    errorMessageKey: 'aiUsage:AI_USAGE_TOAST_EXPORT_ERROR',
  })
